import React, { useState } from 'react';
import DocumentosOportunidade from '../DocumentosOportunidade';
import AnotacoesSection from '../../deals/components/AnotacoesSection';

interface DocumentosOportunidadeTabsProps {
    oportunidadeId: number;
}

const DocumentosOportunidadeTabs: React.FC<DocumentosOportunidadeTabsProps> = ({
    oportunidadeId
}) => {
    const [activeTab, setActiveTab] = useState('documentos');

    return (
        <div className="card">
            <div className="card-header pb-0">
                <ul className="nav nav-tabs nav-tabs-bordered">
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'documentos' ? 'active' : ''}`}
                            onClick={() => setActiveTab('documentos')}
                        >
                            <i className="ti ti-file me-1"></i>
                            Documentos
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'anotacoes' ? 'active' : ''}`}
                            onClick={() => setActiveTab('anotacoes')}
                        >
                            <i className="ti ti-notes me-1"></i>
                            Anotações
                        </button>
                    </li>
                </ul>
            </div>
            <div className="card-body">
                <div className="tab-content">
                    {/* Aba de Documentos */}
                    <div className={`tab-pane fade ${activeTab === 'documentos' ? 'show active' : ''}`}>
                        <DocumentosOportunidade oportunidadeId={oportunidadeId} />
                    </div>

                    {/* Aba de Anotações */}
                    <div className={`tab-pane fade ${activeTab === 'anotacoes' ? 'show active' : ''}`}>
                        <AnotacoesSection oportunidadeId={oportunidadeId} readOnly />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DocumentosOportunidadeTabs;